import { NextPage } from 'next';
import { Home } from '../components/home/ecosystem';

const HomePage: NextPage = () => ( <Home/> );

export default HomePage;
